import { useEffect, useRef } from 'react';

export function useExternalScripts({ url }) {
    useEffect(() => {
        const head = document.querySelector("head");
        const script = document.createElement("script");

        script.setAttribute("src", url);
        head.appendChild(script);

        return () => {
            head.removeChild(script);
        };
    }, [url]);
};

export const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);  useEffect(() => {
      if (didMount.current) {
        func();
      } else {
        didMount.current = true;
      }
    }, deps);
  };